export const DefaultTitleXLargeFactory = ({ theme }) => ({
  fontSize: "32px",
  lineHeight: "150%",
  fontWeight: 600,

  [theme.breakpoint.lg()]: {
    fontSize: "40px",
  },
});

export const DefaultTitleLargeFactory = ({ theme }) => ({
  fontSize: "28px",
  lineHeight: "150%",
  fontWeight: 600,
  marginBotton: "12px",

  [theme.breakpoint.lg()]: {
    fontSize: "32px",
  },
});

export const DefaultTitleSmallFactory = ({ theme }) => ({
  fontSize: "20px",
  lineHeight: "150%",
  fontWeight: 400,

  [theme.breakpoint.lg()]: {
    fontSize: "24px",
  },
});

export const DefaultTitleMediumFactory = ({ theme }) => ({
  fontSize: "24px",
  lineHeight: "150%",
  fontWeight: 600,
  marginBotton: "12px",

  [theme.breakpoint.lg()]: {
    fontSize: "28px",
  },
});

export const DefaultParagraphLargeFactory = ({ theme }) => ({
  fontSize: "18px",
  lineHeight: "160%",
  fontWeight: 400,

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
});

export const DefaultParagraphMediumFactory = ({ theme }) => ({
  fontSize: "16px",
  lineHeight: "150%",
  fontWeight: 400,

  [theme.breakpoint.lg()]: {
    fontSize: "18px",
  },
});

export const DefaultParagraphSmallFactory = ({ theme }) => ({
  fontSize: "14px",
  lineHeight: "150%",
  fontWeight: 600,

  [theme.breakpoint.lg()]: {
    fontSize: "16px",
  },
});
